"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _globeDark = _interopRequireDefault(require("./images/globe-dark.png"));

var _globeLight = _interopRequireDefault(require("./images/globe-light.png"));

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var COOKIE_LANGUAGE = 'nf_lang';

var LocaleSelector = /*#__PURE__*/function (_react$Component) {
  _inheritsLoose(LocaleSelector, _react$Component);

  var _super = _createSuper(LocaleSelector);

  function LocaleSelector() {
    var _this;

    _this = _react$Component.apply(this, arguments) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: '',
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      return _this.setState({
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onToggle", function () {
      return _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var originalPath = _this.context.language.originalPath;
      var pages = _this.props.pages;

      if (value === _this.state.selected) {
        return;
      }

      _this.setState({
        selected: value,
        open: false
      }, function () {
        _jsCookie["default"].set(COOKIE_LANGUAGE, value, (0, _Util.getCookieOptions)());

        var newPath = _this.generateNewPath(value, originalPath);

        if (pages[newPath]) {
          window.location.href = newPath;
        } else {
          window.location.href = "/".concat(value);
        }
      });
    });

    return _this;
  }

  var _proto = LocaleSelector.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var language = this.context.language;

    if (!language) {
      return;
    }

    this.setState({
      selected: language.locale || language.detected
    }, function () {
      _jsCookie["default"].set(COOKIE_LANGUAGE, _this2.state.selected, (0, _Util.getCookieOptions)());
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var open = this.state.open;

    var _this$props = this.props,
        pages = _this$props.pages,
        dark = _this$props.dark,
        rest = _objectWithoutProperties(_this$props, ["pages", "dark"]);

    return _react["default"].createElement(Div, Object.assign({
      component: "div",
      dark: dark
    }, rest), _react["default"].createElement(_IconButton["default"], {
      buttonRef: function buttonRef(node) {
        _this3.anchorEl = node;
      },
      className: "trigger",
      onClick: this.onToggle
    }, _react["default"].createElement("img", {
      src: dark ? _globeDark["default"] : _globeLight["default"],
      alt: ""
    })), _react["default"].createElement(_Popper["default"], {
      open: open,
      anchorEl: this.anchorEl,
      transition: true,
      disablePortal: true
    }, function (_ref) {
      var TransitionProps = _ref.TransitionProps,
          placement = _ref.placement;
      return _react["default"].createElement(_Grow["default"], Object.assign({}, TransitionProps, {
        style: {
          transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
        }
      }), _react["default"].createElement("div", {
        className: "langs"
      }, _react["default"].createElement(_ClickAwayListener["default"], {
        onClickAway: _this3.onClose
      }, _react["default"].createElement(_MenuList["default"], null, _react["default"].createElement(_MenuItem["default"], {
        className: "lang-item",
        onClick: _this3.onChange.bind(_this3, 'en')
      }, "English"), _react["default"].createElement(_MenuItem["default"], {
        className: "lang-item",
        onClick: _this3.onChange.bind(_this3, 'zh')
      }, "\u7B80\u4F53\u4E2D\u6587")))));
    }));
  };

  _proto.generateNewPath = function generateNewPath(locale, originalPath) {
    var languages = this.context.language.languages;
    var newPath = originalPath;
    languages.forEach(function (x) {
      newPath = newPath.replace("/".concat(x.value, "/"), '/');
    });
    return "/".concat(locale).concat(newPath);
  };

  return LocaleSelector;
}(_react.Component);

exports["default"] = LocaleSelector;

_defineProperty(LocaleSelector, "contextTypes", {
  language: _propTypes["default"].object
});

_defineProperty(LocaleSelector, "propTypes", {
  pages: _propTypes["default"].object,
  dark: _propTypes["default"].bool,
  color: _propTypes["default"].string
});

_defineProperty(LocaleSelector, "defaultProps", {
  dark: false,
  pages: {},
  color: ''
});

var Div = (0, _styledComponents["default"])(_Typography["default"]).withConfig({
  displayName: "LocaleSelector__Div",
  componentId: "sc-1oxzpu5-0"
})([".trigger img{width:24px;height:24px;}.langs{background:", ";}.lang-item{font-size:16px;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:2px;text-align:center;color:", ";cursor:pointer;display:block;padding:16px;}"], function (props) {
  return (0, _Util.getBackground)(props);
}, function (props) {
  return (0, _Util.getColor)(props);
});